<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button" :to="{ path: '/card/edit/' }"><i class="fa fa-plus"></i></router-link>
          </div>
          <h1>Kártya lista</h1>

          <div class="row">
            <div class="col-sm-12">
              <h2>Kereső</h2>
            </div>
            <div class="col-sm-2">
              <inputbox id="owner_name" @keydownEnter="searchClick" label="Kártya tulajdonos" id="owner_name" name="owner_name" v-model="search.owner_name"></inputbox>
            </div>
            <div class="col-sm-2">
              <inputbox regexp_filter="[0-9]+" id="card_number" @keydownEnter="searchClick" label="Kártya szám" id="card_number" name="card_number" v-model="search.card_number"></inputbox>
            </div>
            <div class="col-sm-1">
              <inputbox regexp_filter="[a-zA-Z0-9]+" maxlength="8" @keydownEnter="searchClick" id="rfid" label="RF ID" id="rfid" name="rfid" v-model="search.rfid"></inputbox>
            </div>
            <div class="col-sm-3">
              <inputbox regexp_filter="[a-zA-Z0-9]+" maxlength="10" @keydownEnter="searchClick" id="plate_number" label="Rendszám" id="plate_number" name="plate_number" v-model="search.plate_number"></inputbox>
            </div>
            <div class="col-sm-2">
              <comboboxV2 id="active" label="Státusz" name="active" v-model="search.active" :options="status_opts"/>
            </div>
            <div class="col-sm-2">
              <button class="button with-icon" style="margin-top: 24px" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
            </div>
          </div>

          <div v-if="this.cards.length > 0" class="table-with-title">
            <h2>Kártya lista</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Tulajdonos</th>
                  <th>Kártya szám</th>
                  <th>Rf ID</th>
                  <th>Státusz</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="card in cards">
                  <td>{{card.owner_name}}</td>
                  <td>{{card.card_rule_prefix}}{{card.card_number}}</td>
                  <td>{{card.rf_id}}</td>
                  <td>
                    <i v-if="card.active == 1" class="fa fa-check"></i>
                    <i v-if="card.active == 0" class="fa fa-minus"></i>
                  </td>
                  <td class="buttons">
                    <router-link v-if="$root.user.filter_element == 0" class="small-button" :to="{ path: '/card/edit/', query: cardDetailQuery(card.element_id)}"><i class="fa fa-pencil-alt"></i></router-link>
                    <a href="javascript:void(0)" v-if="$root.user.filter_element == 1" @click="editButtonInfo" class="small-button"><i class="fa fa-pencil-alt"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination v-if="cards.length > 0" showcombo="1" :limit="search.limit" :amount="search.amount" v-on:pageChanged="pageChanged" v-model="search.page"></pagination>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      search: {
        card_number: '',
        owner_name: '',
        rfid: '',
        plate_number: '',
        page: 1,
        limit: 100,
        amount: 0,
        active: 1
      },
      status_opts: [
        {
          label: '- összes -',
          value: 2
        },
        {
          label: 'csak aktív',
          value: 1
        },
        {
          label: 'csak inaktív',
          value: 0
        }
      ],
      cards: [],
      socket: ''
    }
  },

  watch: {
    '$route': 'routerChange'
  },

  created: function() {
    this.routerChange();
    this.watchCardReader();
  },

  mounted: function() {

  },

  beforeDestroy: function() {
    this.socket.close();
  },

  methods: {
    cardDetailQuery(cardID) {
      var q = JSON.parse(JSON.stringify(this.search));
      q.cardID = cardID;
      return q;
    },

    editButtonInfo: function() {
      swal('Figyelem', 'Ez a művelet nem engedélyezett aktív csoportszűrő esetén.', 'warning');
    },

    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.search = $.extend(this.search, JSON.parse(JSON.stringify(this.$route.query)));
      }

      this.getCards();
    },

    watchCardReader: function() {
      if (this.socket.readyState === WebSocket.OPEN) {
        this.socket.close();
      }

      var _this = this;
      try {
        this.socket = new WebSocket("wss://kmr-reader.uninet.hu:8080");

        this.socket.onmessage = function (event) {
          if (event.data != undefined) {
            _this.clearSearchFields();
            _this.search.rfid = event.data;
            _this.searchClick();
          }
        };
      } catch(err) {

      }
    },

    clearSearchFields: function() {
      this.search.card_number = '';
      this.search.owner_name = '';
      this.search.rfid = '';
    },

    searchClick: function() {
      this.search.page = 1;
      this.$router.push({path: '/cards', query: this.search});
    },

    pageChanged: function(val) {
      this.search.page = val;
      this.$router.push({path: '/cards', query: this.search});
    },

    getCards: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('cards/' + _this.$root.user.apikey, {
          data: _this.search,
          method: 'POST',
          success: function(response) {
            _this.cards = response.cards;
            _this.search.amount = response.amount;
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// cards.vue?31d38415